import { EMPTY_OBJECT } from '../../../constants/common'
import { stopPropagation } from '../../../utils/events'
import {
  BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER,
  BUTTON_HEIGHT_24,
  ButtonArrow,
} from '../../Button'
import { useSelectContext } from '../Select.hooks'

function ButtonTextSelectControl({
  ArrowIcon,
  Button = ButtonArrow,
  buttonProps: { height = BUTTON_HEIGHT_24, ...buttonProps } = EMPTY_OBJECT,
  closeTooltipText,
  getTooltip = null,
  iconPlacement = BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER,
  openTooltipText,
  ref,
  refs,
  ...restProps
}) {
  const { blocked, disabled, handleToggleOpen, isOpen } = useSelectContext()

  function handleClick(event) {
    stopPropagation(event)

    if (!disabled && !blocked) {
      handleToggleOpen()
    }
  }

  return (
    <div {...restProps} ref={refs.setReference || ref} onClick={handleClick}>
      <Button
        {...buttonProps}
        ArrowIcon={ArrowIcon}
        closeTooltipText={closeTooltipText}
        getTooltip={getTooltip}
        height={height}
        iconPlacement={iconPlacement}
        isOpen={isOpen}
        openTooltipText={openTooltipText}
      />
    </div>
  )
}

export default ButtonTextSelectControl
